import React from "react";
import { Link } from "react-router-dom";
import {
  openAndroidStoreLink,
  openIosStoreLink,
} from "../utils/storeRedirect";

const iPhoneMock = "https://d1vqw4it8x9uac.cloudfront.net/admin/iphone-hero-1790236892.png";


function RevampHero() {
  return (
    <section className="revamp-hero-wrap" aria-label="Hero">
      <section className="revamp-hero">
        <div className="revamp-hero-inner">
          {/* Old hero layout kept for reference (do not delete).
          <div className="revamp-hero-content">...</div>
          */}

          <div className="revamp-hero-split">
            <div className="revamp-hero-left">
              <div className="revamp-hero-eyebrow">
                <span className="revamp-hero-eyebrow-muted">India&apos;s</span>
                <span className="revamp-hero-eyebrow-accent">Home App</span>
              </div>

              <h1 className="revamp-hero-heading">
                Planning your home?
                <br />
                Get the right professionals in{" "}
                <br />
                <span className="revamp-hero-heading-accent"> 60 seconds.</span>
              </h1>

              <p className="revamp-hero-subcopy">
                Post your requirement, explore real homes, discover products, and connect with
                verified professionals - all in one place.
              </p>

              <ul className="revamp-hero-feature-list" aria-label="What you can do on Hynt">
                <li className="revamp-hero-feature-item">
                  <span className="revamp-hero-feature-dot" aria-hidden="true" />
                  <span className="revamp-hero-feature-text">Find professionals</span>
                </li>
                <li className="revamp-hero-feature-item">
                  <span className="revamp-hero-feature-dot" aria-hidden="true" />
                  <span className="revamp-hero-feature-text">Explore homes</span>
                </li>
                <li className="revamp-hero-feature-item">
                  <span className="revamp-hero-feature-dot" aria-hidden="true" />
                  <span className="revamp-hero-feature-text">Discover products</span>
                </li>
              </ul>

              <div className="revamp-hero-metrics">
                <div className="revamp-hero-metric">
                  <div className="revamp-hero-metric-value">50+</div>
                  <div className="revamp-hero-metric-label">Daily Professionals</div>
                </div>
                <div className="revamp-hero-metric">
                  <div className="revamp-hero-metric-value">100+</div>
                  <div className="revamp-hero-metric-label">New Products Everyday</div>
                </div>
                <div className="revamp-hero-metric">
                  <div className="revamp-hero-metric-value">200+</div>
                  <div className="revamp-hero-metric-label">New real Inspirations</div>
                </div>
              </div>

              <div className="revamp-hero-cta-stack">
                <Link to="/enquiry" className="revamp-hero-cta-primary">
                  Tell us what you need
                </Link>

                <div className="revamp-hero-or-row" aria-hidden="true">
                  <span className="revamp-hero-or-line" />
                  <span className="revamp-hero-or-text">OR</span>
                  <span className="revamp-hero-or-line" />
                </div>

                <div className="revamp-hero-stores">
                  <button
                    type="button"
                    className="revamp-hero-store-btn"
                    onClick={openIosStoreLink}
                    aria-label="Download on the App Store"
                  >
                    <img src="/appstoreNew.svg" alt="" />
                  </button>
                  <button
                    type="button"
                    className="revamp-hero-store-btn"
                    onClick={openAndroidStoreLink}
                    aria-label="Get it on Google Play"
                  >
                    <img src="/playstoreNew.svg" alt="" />
                  </button>
                </div>

                {/* Keep this navigation available, but don't show yet. */}
                {/*
                <Link to="/create-business" className="revamp-hero-secondary-btn revamp-hero-action-outline">
                  I have a business
                </Link>
                */}
              </div>
            </div>

            <div className="revamp-hero-right" aria-hidden="true">
              <div className="revamp-hero-phone-stage">
                <img className="revamp-hero-phone" src={iPhoneMock} alt="" />
                {/* <img className="revamp-hero-phone" src={HouseRestylingIllustration} alt="" /> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
}

export default RevampHero;
